import { render, staticRenderFns } from "./LiveScript.vue?vue&type=template&id=6c540940&scoped=true"
import script from "./LiveScript.vue?vue&type=script&lang=js"
export * from "./LiveScript.vue?vue&type=script&lang=js"
import style0 from "./LiveScript.vue?vue&type=style&index=0&id=6c540940&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c540940",
  null
  
)

export default component.exports